var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviewPhoto = function SvgPreviewPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.441,
    width: 100.564,
    height: 96,
    rx: 2.874,
    fill: "#BBB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.453,
    cy: 27.488,
    r: 4.79,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 80.098 19.436-24.781 12.876 24.781 34.65-54.92 35.075 54.92",
    stroke: "#DFE2EE",
    strokeWidth: 1.437
  })));
};
export { SvgPreviewPhoto as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTA0IiBoZWlnaHQ9Ijk2IiB2aWV3Qm94PSIwIDAgMTA0IDk2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIxLjQ0MTQxIiB3aWR0aD0iMTAwLjU2NCIgaGVpZ2h0PSI5NiIgcng9IjIuODc0MjgiIGZpbGw9IiNCQkJCQkIiLz4KPGNpcmNsZSBjeD0iMjguNDUyNiIgY3k9IjI3LjQ4ODIiIHI9IjQuNzkwNDYiIGZpbGw9IiNEOUQ5RDkiLz4KPHBhdGggZD0iTTEgODAuMDk4TDIwLjQzNTYgNTUuMzE2OUwzMy4zMTE3IDgwLjA5OEw2Ny45NjE3IDI1LjE3NzdMMTAzLjAzNyA4MC4wOTgiIHN0cm9rZT0iI0RGRTJFRSIgc3Ryb2tlLXdpZHRoPSIxLjQzNzE0Ii8+Cjwvc3ZnPgo=";